<template>
  <div :name="name">
    <label>{{item.label}}</label>
    <p v-show="showErrorMessage" class="errorMsg">{{errorMsg}}</p>
    <input type="text" v-model.trim="text" :placeholder="placeholder" :disabled="disabled" ref="input"
           @keyup="processKey"
           @keydown="processControl"
           @focus="open"
           :name="refs"

           v-on:blur="eventBlur"
           v-on:focus="eventFocus"
    >
    <div class="sg-clear"
         @click="clear"
         v-show="text"
         v-if="!disabled">
      <span>×</span>
    </div>

    <v-drop-down ref="drop" :re-open="false" :animated="false" @show-change="showChange">
      <ul class="sg-results" :style="{width: width+'px'}" ref="list" >
        <li :key="index" v-for="(row,index) in listComputed"
            :class="['sg-results__row',{'sg-over': highlight === index}]"
            @click="selectItem(row)"
            @mouseenter="highlight = index"
            @mouseleave="highlight = -1"
            v-html="getRow(row)" ></li>
      </ul>
    </v-drop-down>
  </div>
</template>

<script>
  //todo это пиздец, тут нужна ковровая бомбардировка

  import drop from 'v-dropdown';
  import {mapGetters, mapState} from 'vuex';
  import DataForInput from '@/gavnoCode/longFormOptions';
  export default {
    name: "v-suggest",
    components: { 'v-drop-down': drop },
    props: {
      data: Array,
      name:String,
      keyField: {
        type: String,
        default: 'id'
      },
      placeholder: String,
      delay: {
        type: Number,
        default: 0
      },
      disabled: {
        type: Boolean,
        default: false
      },
      target: {
        type: String,
        default: ''
      },
      label:{
        type:String,
        default: ''
      },
      refs: {
        type: String,
        default: 'null'
      },
      form:{
        type: String,
        default: 'null'
      }
    },
    data(){
      return {
        showField:'value',
        list: [],
        highlight: -1,
        width: 0,
        dropShow: false,
        last: null,
        lastInputTime: -1,
        listComputed:[],
        item: DataForInput[this.refs],
        isTimeToShowError:false
      };
    },
    methods: {
      open(){
        if(this.disabled) return;
        this.populate();
        if(!this.dropShow && this.listComputed.length) this.$refs.drop.$emit('show', this.$refs.input);
        this.adjust();
      },
      close(){
        if(this.dropShow) this.$refs.drop.$emit('show');
        this.highlight = -1;
      },
      clear(){
        this.text = '';
        this.populate();
        this.inputFocus();
      },
      inputFocus(){
        this.$refs.input.focus();
      },
      getRow(row){
        if(typeof this.showField === 'string') return row[this.showField];
        else if(typeof this.showField === 'function') return this.showField(row);
      },
      showChange(val){
        this.dropShow = val;
        if(!val) this.highlight = -1;
      },
      processKey(e){
        if ([38, 40, 27, 13, 9].includes(e.keyCode)) return;
        this.lastInputTime = e.timeStamp;
        setTimeout(()=>{
          if((e.timeStamp - this.lastInputTime) === 0) {
            this.populate();
            this.checkOpen();
          }
        }, this.delay * 1000);
      },
      processControl(e){
        if ([38, 40, 27, 13, 9].includes(e.keyCode)) {
          switch (e.keyCode) {
            case 38:// up
              this.previous();
              break;
            case 40:// down
              this.next();
              break;
            case 9: // tab
            case 13:// enter
              if(this.highlight !== -1) this.selectItem(this.listComputed[this.highlight]);
              break;
            case 27:// escape
              this.close();
              break;
          }
        }
      },
      selectItem(row){
        this.text = this.getRow(row);
        this.$emit('values', row);
        this.close();
        let utiputi = {
          target:this.refs + '_DADATA',
          form:this.form,
          value: JSON.stringify(row)
        };
        this.$store.dispatch('saveSendData',utiputi);

        if (this.refs == 'RESIDENTIAL_ADDRESS') {
          let self = this;
          setTimeout(function(){
            self.$emit('checkThisAdress');
          },300);

        }
      },
      next(){
        if(!this.dropShow) this.open();
        if(this.highlight < (this.listComputed.length-1)) {
          this.highlight++;
          this.$nextTick(()=>{
            let cur = this.$refs.list.querySelectorAll('.sg-over')[0],
              curPos = cur.getBoundingClientRect(),
              listPos = this.$refs.list.getBoundingClientRect(),
              dist = (this.$refs.list.scrollTop + curPos.bottom) - listPos.bottom;
            if(dist) this.$refs.list.scrollTop = dist;
          });
        }
      },
      previous(){
        if(this.highlight === 0) return;
        if(!this.dropShow) this.open();
        this.highlight = this.highlight === -1 ? this.listComputed.length - 1 : --this.highlight;
        this.$nextTick(()=>{
          let cur = this.$refs.list.querySelectorAll('.sg-over')[0],
            curPos = cur.getBoundingClientRect(),
            listPos = this.$refs.list.getBoundingClientRect(),
            dist = curPos.top - listPos.top;
          if(dist < 0) this.$refs.list.scrollTop += dist;
        });
      },
      checkOpen(){
        this.listComputed.length ? this.open() : this.close();
      },
      adjust(){
        let inputWidth = this.$refs.input.getBoundingClientRect().width;

        //minimize width 200px
        if(this.width === 198) {
          if(inputWidth > 198) this.width = inputWidth;
        }else{
          if((inputWidth - 2) !== this.width) this.width = (inputWidth > 200 ? inputWidth : 200) - 2;
        }
      },
      populate(){
        if(Array.isArray(this.data) && this.data.length){
          this.list = this.text ? this.data.concat().filter(value=>{
            let result = this.getRow(value);
            return String(result);
          }) : [];
          this.last = this.text;
        }
      },
      getSuggest(query){
        let dadataSuggest = [];
        let self = this;
        this.$myApi.suggestResultPassport(query).then(resp => {
          dadataSuggest = resp;
          self.listComputed = (Array.isArray(dadataSuggest) && dadataSuggest.length) ? dadataSuggest : [];
        });
      },
      eventBlur: function () {
        this.isTimeToShowError = true;
      },
      eventFocus: function(){
        this.isTimeToShowError = false;
      }
    },
    watch: {
      text(){
        // this.getSuggest();
      },
      VuexPASSPORT_DEP_CODE:function(newVal,oldVal){
        this.getSuggest(newVal);
      }
    },
    computed:{
      status :function(){
        return this.statusVuex[this.form][this.refs].code;
      },
      errorMsg :function(){
        return this.statusVuex[this.form][this.refs].msg;
      },
      showErrorMessage:function(){
        if (this.status != 0 && this.isTimeToShowError) {
          return true;
        }
        return false;
      },
      text:{
        get(){
          return this.valueVuex[this.form][this.refs]
        },
        set(value){
          let utiputi = {
            target:this.refs,
            form:this.form,
            value: value
          };
          this.$store.dispatch('saveSendData',utiputi);
        }
      },
      ...mapState({
        valueVuex: state => state.requestField.sendData,
        VuexPASSPORT_DEP_CODE: state => state.requestField.sendData['request']['PASSPORT_DEP_CODE'],
        statusVuex: state => state.requestField.workData
      })
    },
    mounted(){
      let tmpClass = this.$el.className;
      this.$el.className = 'v-suggest';
      this.$refs.input.className = tmpClass;
      //this.populate();
      this.adjust();
    }
  }
</script>

<style lang="scss" scoped>
  div.v-suggest{
    position: relative;
    input[type="text"] {
      display: block;

      outline: 0;
      /*&::-webkit-input-placeholder{ color:#aaa; }*/
      &:hover { background-color: #f5f5f5; }
      &:focus{
        /*border: 1px solid #999;*/
        border-radius: 2px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        background-color: #fff;
        color: black;
      }
      &[disabled] { background-color: #eee;color: #666;cursor: not-allowed; }
    }

  }
  div.sg-clear {display: none}
  ul.sg-results {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";;
    min-width: 250px;
    max-height: 300px;
    overflow-y: auto;
    padding: 5px 0;
    margin: 0;
    li.sg-results__row {
      height: auto !important;
      line-height: 1.4;
      margin: 0;
      overflow: hidden;
      padding: 5px 10px;
      position: relative;
      text-align: left;
      /*white-space: nowrap;*/
      white-space: normal;
      word-break: break-all;
      font-size: 14px;
      color: #333;
      cursor: default;
      &.sg-over {
        background-color: #53A4EA !important;color: #fff !important;cursor: pointer;
      }
    }
  }
  .errorMsg{
    color: red;
  }
</style>
